
import { useEffect } from 'react'
import Select from 'react-select'
import { EquipmentNameDDLAPI, EquipmentTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const EquipmentNameDataDDL = (props) => {
    const { EquipmentName, setEquipmentName, ScreenName,WardName,EquipmentType } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
// console.log(WardName.ID)
    useEffect(() => {
        const data = {
            M_WardID:WardName.ID,
            M_STP_EquipmentTypeID: EquipmentType.ID,
            M_UserID: UserID,
            token: token,
        }
        if(EquipmentType.ID !==0){
        dispatch(EquipmentNameDDLAPI({ data }))
        }
    }, [WardName.ID,EquipmentType.ID])

    const { EquipmentNameData } = useSelector(state => state.EquipmentNameDDL)

    useEffect(() => {
        handleSTPEquipmentNameDDL()
    }, [EquipmentNameData])

    const handleSTPEquipmentNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (EquipmentNameData && EquipmentNameData.table && EquipmentNameData.table.length > 0) {
            let list = EquipmentNameData.table.map((item, index) => ({
                value: item.m_stP_EquipmentMasterID,
                label: item.equipmentDetails,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setEquipmentName({ ...EquipmentName, DDL: list })
        }
        else {
            setEquipmentName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Equipment Name </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: EquipmentName.ID, label: EquipmentName.Label }}
                onChange={(e) => {
                    e ?
                        setEquipmentName({ ...EquipmentName, ID: e.value, Label: e.label })
                        :
                        setEquipmentName({ ...EquipmentName, ID: 0, Label: "Select..." })

                }}
                options={EquipmentName.DDL}
            />
        </div>
    )
}